/* eslint-disable react-hooks/exhaustive-deps */

import React, { ReactElement, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Cards, StyledDiv } from '../../../../styled-components'
import {
  TrainingGroup,
  Question,
  Category,
  Part,
  Training,
} from '../../../../../../types/training'
import AdminTemplate from '../../../../../base-template'
import Card from '../../../../card'
import PartAddEditQuiz from '../edit-quiz'
import Text from '../../../../../text'
import Select from '../../../../../select'
import { updatePart } from '../../../../../../api/part'
import { Alert } from '../../../../../../constants/sweet-alert'
import Button from '../../../../../button'
import Icon from '../../../../../icon'
import DeleteModal from '../../../../../delete-modal'
import { deleteQuestion } from '../../../../../../api/question'

interface AdminPartQuizProps {
  trainingsGroup: TrainingGroup
  training: Training
  category: Category | undefined
  part: Part | undefined
}

const AdminPartQuiz = ({
  trainingsGroup,
  training,
  category,
  part,
}: AdminPartQuizProps): ReactElement => {
  const [questions, setQuestions] = useState(part?.questions)
  const [editQuestion, setEditQuestion] = useState<Question | undefined>(
    undefined
  )
  const [deletedQuestion, setDeletedQuestion] = useState<Question | undefined>(
    undefined
  )
  const [loadingDelete, setLoadingDelete] = useState<boolean>(false)

  const [add, setAdd] = useState<Question | undefined>(undefined)
  const [quizType, setQuizType] = useState(part?.quizType as string)
  const [loading, setLoading] = useState(false)

  const selectOptionsQuiz = [
    { id: 0, value: 'dropdown', label: 'dropdown' },
    { id: 1, value: 'tickbox', label: 'tickbox' },
    { id: 2, value: 'radio', label: 'radio' },
  ]
  const navigate = useNavigate()

  const onEditSave = () => {
    setLoading(true)

    if (part) {
      const payload = {
        quizType,
      }
      updatePart(part.id, payload).then((status) => {
        if (status === 200) {
          setLoading(false)

          Alert.fire({
            icon: 'success',
            title: `Updated`,
          })
          navigate(0)
        } else {
          setLoading(false)

          Alert.fire({
            icon: 'error',
            title: `Error`,
          })
        }
      })
    }
  }

  const removeQuestion = () => {
    setLoadingDelete(true)
    deleteQuestion(deletedQuestion?.id).then((result) => {
      if (result === 200) {
        const findQuestionIndex = questions?.findIndex(
          (el) => el.id === deletedQuestion?.id
        )
        const oldQuestions = questions
        oldQuestions?.splice(findQuestionIndex as number, 1)
        setQuestions(oldQuestions)
        setDeletedQuestion(undefined)
        Alert.fire({
          icon: 'success',
          title: `Deleted`,
        })
      } else {
        Alert.fire({
          icon: 'error',
          title: `Error`,
        })
      }
      setLoadingDelete(false)
    })
  }

  if (category && part && questions) {
    return (
      <>
        {deletedQuestion ? (
          <DeleteModal
            onCancel={() => setDeletedQuestion(undefined)}
            title={deletedQuestion.text}
            onDelete={() => removeQuestion()}
            loadingDelete={loadingDelete}
          />
        ) : null}
        <AdminTemplate
          onAddClick={() =>
            setAdd({ id: '', text: '', answers: [], correctAnswers: [] })
          }
          adminTemplate
          navigation={[
            {
              title: trainingsGroup.title,
              link: `/trainings?type=${trainingsGroup.name}`,
            },
            {
              title: training.title,
              link: `/trainings?type=${trainingsGroup.name}&training_id=${training.id}`,
            },
            {
              title: category.title,
              link: `/trainings?type=${trainingsGroup.name}&training_id=${training.id}&category_id=${category.id}`,
            },
            {
              title: part.title,
              link: `/trainings?type=${trainingsGroup.name}&training_id=${training.id}&category_id=${category.id}&part_id=${part.id}`,
            },
          ]}
        >
          {add ? (
            <PartAddEditQuiz
              part={part}
              onClose={() => setAdd(undefined)}
              question={add}
            />
          ) : editQuestion ? (
            <PartAddEditQuiz
              part={part}
              onClose={() => setEditQuestion(undefined)}
              question={editQuestion}
            />
          ) : (
            <Cards>
              {questions?.length === 0 ? (
                <StyledDiv>
                  <Text size="small">نوع التمرين</Text>
                  <Select
                    defaultValue={selectOptionsQuiz.find(
                      (e) => e.value === part.quizType
                    )}
                    onChange={(selectedItem) => {
                      setQuizType(selectedItem.value)
                    }}
                    options={selectOptionsQuiz}
                  />
                  <Button loading={loading} onClick={onEditSave} color="red">
                    <Icon name="entypo:check" />
                  </Button>
                </StyledDiv>
              ) : (
                questions.map((question) => (
                  <Card
                    element={question}
                    key={question.id}
                    onClickEdit={(q) =>
                      setEditQuestion(q as unknown as Question)
                    }
                    onDeleteClick={(q) =>
                      setDeletedQuestion(q as unknown as Question)
                    }
                  />
                ))
              )}
            </Cards>
          )}
        </AdminTemplate>
      </>
    )
  }
  return <></>
}

export default AdminPartQuiz
